import axios from './index';

export interface publicFormResponse {
  success?: boolean;
  error?: string | boolean;
}

export const postContactUs = (data: any) => {
  return axios.post<publicFormResponse>('/api/modal/contact-us', data);
};

export const postRemovalRequest = (data: any) => {
  return axios.post<publicFormResponse>('/api/modal/removal-request', data);
};
